module.exports = __webpack_public_path__ + "img/4ne.5d3009ae.svg";